export default __webpack_public_path__ + "static/media/chat.8077c550.svg";